import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { FloppyDisk } from "@phosphor-icons/react";

const PAGES = [
  { key: "home", label: "Accueil" },
  { key: "assurances-pro", label: "Assurances professionnelles" },
  { key: "sante-prevoyance", label: "Santé & prévoyance" },
  { key: "patrimoine", label: "Patrimoine" },
  { key: "methode", label: "Méthode" },
  { key: "partenaires", label: "Partenaires" },
  { key: "contact", label: "Contact" },
  { key: "mentions-legales", label: "Mentions légales" },
];

export default function AdminSEO() {
  const [data, setData] = useState({});

  const load = async () => {
    const { data } = await api.get("/seo");
    setData(data || {});
  };
  useEffect(() => { load(); }, []);

  const update = (page, field, value) =>
    setData((d) => ({ ...d, [page]: { ...(d[page] || {}), [field]: value } }));

  const save = async (page) => {
    const row = data[page] || {};
    try {
      await api.put(`/seo/${page}`, {
        title: row.title || "", description: row.description || "", keywords: row.keywords || "",
      });
      toast.success("SEO enregistré");
    } catch (err) { toast.error(formatApiError(err)); }
  };

  const inputCls = "w-full bg-ducs-night border border-ducs-gold/25 px-3 py-2 text-ducs-cream rounded-sm text-sm focus:border-ducs-gold";

  return (
    <div data-testid="admin-seo" className="p-8 md:p-10">
      <div className="label-caps mb-3">SEO</div>
      <h1 className="font-serif text-3xl md:text-4xl text-ducs-cream">Balises & meta descriptions</h1>
      <p className="text-ducs-mist mt-2">Optimisez chaque page pour les moteurs de recherche.</p>

      <div className="mt-10 space-y-4">
        {PAGES.map((p) => {
          const row = data[p.key] || {};
          return (
            <div key={p.key} className="card-ducs p-6 hover:translate-y-0">
              <div className="flex items-center justify-between mb-3">
                <h3 className="font-serif text-xl text-ducs-cream">{p.label}</h3>
                <span className="text-xs text-ducs-mist">/{p.key === "home" ? "" : p.key}</span>
              </div>
              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <label className="label-caps block mb-2">Title</label>
                  <input className={inputCls} value={row.title || ""} onChange={(e) => update(p.key, "title", e.target.value)} data-testid={`seo-title-${p.key}`} />
                </div>
                <div>
                  <label className="label-caps block mb-2">Keywords</label>
                  <input className={inputCls} value={row.keywords || ""} onChange={(e) => update(p.key, "keywords", e.target.value)} data-testid={`seo-keywords-${p.key}`} />
                </div>
                <div className="md:col-span-2">
                  <label className="label-caps block mb-2">Description</label>
                  <textarea className={inputCls} rows={2} value={row.description || ""} onChange={(e) => update(p.key, "description", e.target.value)} data-testid={`seo-description-${p.key}`} />
                </div>
              </div>
              <button onClick={() => save(p.key)} className="btn-primary mt-4" data-testid={`seo-save-${p.key}`}>
                <FloppyDisk size={16} /> Enregistrer
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
